import { render, staticRenderFns } from "./ActivityOver.vue?vue&type=template&id=2e387a28&scoped=true"
import script from "./ActivityOver.vue?vue&type=script&lang=js"
export * from "./ActivityOver.vue?vue&type=script&lang=js"
import style0 from "./ActivityOver.vue?vue&type=style&index=0&id=2e387a28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e387a28",
  null
  
)

export default component.exports